// Who started a run, for DISPLAY only (never authorization or ownership checks).
//
// `owner` is the caller's stable token object id. New runs also carry a snapshot of the name and email the token had at
// that moment: top-level `triggered_by` on an accepted trigger response, and `payload.triggered_by` on a stored record.
// It is a snapshot, not a live directory profile, and older records have none. Both fields are optional.

const text = (value) => (typeof value === "string" && value.trim() ? value.trim() : "");

// The snapshot from either place, as { displayName, email } (empty strings when missing).
export const readSnapshot = (source) => {
  const snapshot = source?.triggered_by ?? source?.payload?.triggered_by;
  const object = snapshot && typeof snapshot === "object" ? snapshot : {};
  return { displayName: text(object.display_name), email: text(object.email) };
};

// What to show:
//   1. the name (with the email as the smaller line)   2. the email on its own
//   3. "System" when there is no snapshot and the owner is "system"   4. the raw owner id   5. "Unknown"
// `ownerId` is the raw owner for a copy / detail view.
export const describeCaller = (source) => {
  const { displayName, email } = readSnapshot(source);
  const owner = text(source?.owner);
  if (displayName) return { kind: "person", primary: displayName, secondary: email, ownerId: owner };
  if (email) return { kind: "email", primary: email, secondary: "", ownerId: owner };
  if (owner === "system") return { kind: "system", primary: "System", secondary: "", ownerId: owner };
  if (owner) return { kind: "owner", primary: owner, secondary: "", ownerId: owner };
  return { kind: "unknown", primary: "Unknown", secondary: "", ownerId: "" };
};
